<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-row
      no-gutters
      class="fill-height"
    >
      <!-- LEFT SIDEBAR -->
      <v-col
        cols="3"
        class="pa-3 d-flex flex-column"
      >
        <v-card
          class="pa-4 flex-grow-1"

          rounded
          style="box-shadow: 4px 4px 24px 0px rgba(61, 104, 213, 0.16);"
        >
          <div class="synthesis-ui-grey-01--text text-size-12">
            {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DepositCategories') }}
          </div>
          <!-- Deposits Accordion -->
          <v-expansion-panels
            v-model="panels"
            multiple
            accordion
            flat
            tile
          >
            <!-- Time Deposits -->
            <v-expansion-panel>
              <v-expansion-panel-header
                class="px-3 py-0"
                style="min-height: 50px;"
              >
                {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.TimeDeposits') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list
                  dense
                  class="pa-0"
                >
                  <v-list-item
                    :style="activeDepositTypeStyle('timeDepositsInsured')"
                    @click="selectDepositType('timeDepositsInsured')"
                  >
                    <v-list-item-content>
                      <div class="d-flex flex-row">
                        <div class="font-weight-medium mr-2">
                          •
                        </div> {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Insured') }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    :style="activeDepositTypeStyle('timeDepositsUninsured')"
                    @click="selectDepositType('timeDepositsUninsured')"
                  >
                    <v-list-item-content>
                      <div class="d-flex flex-row">
                        <div class="font-weight-medium mr-2">
                          •
                        </div> {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Uninsured') }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Savings Deposits -->
            <v-expansion-panel>
              <v-expansion-panel-header
                class="px-3 py-0"
                style="min-height: 50px;"
              >
                {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.SavingsDeposits') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pa-0">
                <v-list
                  dense
                  class="pa-0"
                >
                  <v-list-item
                    :style="activeDepositTypeStyle('savingsDepositsInsured')"
                    @click="selectDepositType('savingsDepositsInsured')"
                  >
                    <v-list-item-content>
                      <div class="d-flex flex-row">
                        <div class="font-weight-medium mr-2">
                          •
                        </div> {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Insured') }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    :style="activeDepositTypeStyle('savingsDepositsUninsured')"
                    @click="selectDepositType('savingsDepositsUninsured')"
                  >
                    <v-list-item-content>
                      <div class="d-flex flex-row">
                        <div class="font-weight-medium mr-2">
                          •
                        </div> {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Uninsured') }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Demand Deposits -->
            <v-expansion-panel>
              <v-expansion-panel-header
                class="px-3 py-0"
                style="min-height: 50px;"
              >
                {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DemandDeposits') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pa-0">
                <v-list
                  dense
                  class="pa-0"
                >
                  <v-list-item
                    :style="activeDepositTypeStyle('demandDepositsInsured')"
                    @click="selectDepositType('demandDepositsInsured')"
                  >
                    <v-list-item-content>
                      <div class="d-flex flex-row">
                        <div class="font-weight-medium mr-2">
                          •
                        </div> {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Insured') }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    :style="activeDepositTypeStyle('demandDepositsUninsured')"
                    @click="selectDepositType('demandDepositsUninsured')"
                  >
                    <v-list-item-content>
                      <div class="d-flex flex-row">
                        <div class="font-weight-medium mr-2">
                          •
                        </div> {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Uninsured') }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-row
            no-gutters
            class="mb-3"
          >
            <span
              class="text-size-12 mt-6 d-flex align-center"
              style="color: var(--v-synthesis-ui-grey-01-base);"
            >
              {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.TotalAmountOfFunds') }}
            </span>
          </v-row>
          <div>
            <v-row
              no-gutters
              class="pa-2"
            >
              <v-col
                cols="12"
                no-gutters
                class="pa-2 mb-2 d-flex align-center justify-between"
                style="background-color: var(--v-synthesis-ui-red-08-base); border-radius: 8px; height: 48px;"
              >
                <synthesis-icon
                  name="withdrawn_per_day"
                  class="mr-2"
                />
                <span
                  class="text-size-12 font-weight-bold d-flex align-center "
                  style="color: var(--v-synthesis-ui-red-01-base);"
                >
                  {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.WithdrawnPerDay') }}
                </span>
              </v-col>
              <v-col
                cols="12"
                no-gutters
                class="pa-2 mb-2 d-flex align-center justify-between"
                style="background-color: var(--v-synthesis-ui-red-08-base); border-radius: 8px; height: 48px;"
              >
                <synthesis-icon
                  name="cumulative_withdrawns"
                  class="mr-2"
                />
                <span
                  class="text-size-12 font-weight-medium "
                  style="color: var(--v-synthesis-ui-red-01-base);"
                >
                  {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.CumulativeWithdrawns') }}
                </span>
              </v-col>
              <v-col
                cols="12"
                no-gutters
                class="pa-2 mb-2 d-flex align-center justify-between"
                style="background-color: var(--v-synthesis-ui-green-08-base); border-radius: 8px; height: 48px;"
              >
                <synthesis-icon
                  name="deployed_per_day"
                  class="mr-2"
                />
                <span
                  class="text-size-12 font-weight-medium "
                  style="color: var(--v-synthesis-ui-grey-01-base);"
                >
                  {{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DeployedPerDay') }}
                </span>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>

      <!-- RIGHT PANEL -->
      <v-col
        cols="9"
        class="pa-3  d-flex "
      >
        <v-card
          class="pa-6 flex-grow-1"
          elevation="0"
          style="background-color: var(--v-synthesis-ui-grey-06-base);"
        >
          <!-- Top Info Bar -->
          <div class="d-flex justify-space-between align-center mb-5">
            <span
              class="font-weight-medium text-size-12"
              style="color: var(--v-synthesis-ui-grey-01-base);"
            >
              • {{ leftTableLabel }} →
              <strong>{{ totalAmountOfDepositsGrouped }}</strong>
            </span>
            <span
              class="font-weight-medium text-size-12"
              style="color: var(--v-synthesis-ui-grey-01-base);"
            >
              • {{ tableLabel }} →
              <strong>{{ totalAmountOfDeposits }}</strong>
            </span>
          </div>

          <!-- Crisis Days Row -->
          <v-col
            cols="12"
            class="mb-5 pa-0"
          >
            <v-row
              no-gutters
              class="mb-3"
            >
              <span
                class="text-size-12 font-weight-medium "
                style="color: var(--v-synthesis-ui-grey-01-base);"
              >{{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.CrisisDays') }}</span>
            </v-row>
            <v-row
              no-gutters
              class="d-flex justify-space-around align-center "
              style=" border-radius: 12px; box-shadow: 8px 8px 24px 0px rgba(61, 104, 213, 0.24); height:48px; position:relative;
  "
            >
              <!-- Left caret -->
              <v-icon
                v-if="currentPage > 1"
                style="left: 5px; color: var(--v-synthesis-ui-blue-05-base); position: absolute;"
                @click="currentPage--"
              >
                mdi-chevron-left
              </v-icon>

              <!-- Right caret -->
              <v-icon
                v-if="currentPage < maxPage"
                style="right: 5px; color: var(--v-synthesis-ui-blue-05-base); position: absolute;"
                @click="currentPage++"
              >
                mdi-chevron-right
              </v-icon>
              <div
                v-for="day in getDays"
                :key="day"
                class="text-size-16 font-weight-medium"
                style="color: var(--v-synthesis-ui-blue-04-base);"
              >
                {{ day.toString().padStart(2, '0') }}
              </div>
            </v-row>
          </v-col>

          <v-col
            cols="12"
            class="mb-10 pa-0"
          >
            <v-row
              no-gutters
              class="mb-3"
            >
              <span
                class="text-size-12 font-weight-medium "
                style="color: var(--v-synthesis-ui-grey-01-base);"
              >{{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.WithdrawalPerDayPercentage') }}</span>
            </v-row>
            <v-row
              no-gutters
              class="d-flex justify-space-around align-center"
            >
              <div
                v-for="(percentage, index) in percentagesPerDay"

                :key="'pct-' + index"
                class="text-center mx-3 text-size-14 d-flex align-center"
                style="color: var(--v-synthesis-ui-grey-01-base); min-height: 30px;"
              >
                {{ percentage }}
              </div>
            </v-row>
          </v-col>

          <v-col
            cols="12"
            class="pa-0"
          >
            <v-row
              no-gutters
              class="mb-3 pa-0"
            >
              <span
                class="text-size-12 font-weight-medium "
                style="color: var(--v-synthesis-ui-grey-01-base);"
              >{{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.WithdrawalsPerDayDollars') }}</span>
            </v-row>
            <v-row
              no-gutters
              class="d-flex justify-space-around align-center"
            >
              <div
                v-for="(outflow, index) in outflowPerDay"
                :key="'pct-' + index"
                class="withdrawals-per-day-content"
              >
                {{ formatDay(outflow) }}
              </div>
            </v-row>
          </v-col>
          <div style="margin-top: 150px;">
            <v-row
              no-gutters
              class="mb-3 px-2"
            >
              <span class=" withdrawals-per-day-header">{{ $t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DefenceReadinessOutcome') }}</span>
            </v-row>
            <v-row
              no-gutters
              class="mb-2 px-5 withdrawn-rows-container"
              style="height: 48px; background-color: var(--v-synthesis-ui-red-08-base); border-radius: 8px;"
            >
              <div
                v-for="(day, index) in withdrawnPerDay"
                :key="'pct-' + index"
                class="withdrawn-per-day-content synthesis-ui-red-01--text font-weight-bold text-center"
              >
                {{ formatDay(day) }}
              </div>
            </v-row>
            <v-row
              no-gutters
              class="mb-2 px-5 withdrawn-rows-container"
              style="height: 48px; background-color: var(--v-synthesis-ui-red-08-base); border-radius: 8px;"
            >
              <div
                v-for="(day, index) in cumulativeWithdrawns"
                :key="'pct-' + index"
                class="cumulative-withdrawns synthesis-ui-red-01--text text-size-12 text-center"
              >
                {{ riskBaseCurrencyDisplayName }}{{ day }}
              </div>
            </v-row>
            <v-row
              no-gutters
              class="mb-2 px-5 withdrawn-rows-container"
              style="height: 48px; background-color: var(--v-synthesis-ui-green-08-base); border-radius: 8px;"
            >
              <div
                v-for="(day, index) in deployedPerDay"
                :key="'pct-' + index"
                class="deployed-per-day-content synthesis-ui-grey-01--text font-weight-bold text-center"
              >
                {{ formatDay(day) }}
              </div>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

  <script>
import { toNumberFormatNotationShort } from '@/lib/utils/helper'
import riskBaseCurrency from '@/theme/default/views/risks/mixins/riskBaseCurrency'
import { getDefenceReadinessPagination } from '../utils'
import SynthesisIcon from '@/theme/default/components/common/icons/SynthesisIcon.vue'

export default {
  name      : 'DepositorBehaviorModularView',
  components: {
    SynthesisIcon
  },
  mixins: [riskBaseCurrency],
  props : {
    editMode: {
      type   : Boolean,
      default: false
    },
    tableData: {
      type   : Object,
      default: () => {}
    }
  },
  dataStore: {
    DepositBehavior     : 'RiskLiquidity.DepositBehavior.Data',
    riskBaseCurrencyData: 'Risks.BaseCurrency.Data',
    BankReadiness       : 'RiskLiquidity.BankReadiness.Data'
  },
  data () {
    return {
      panels             : [0, 1, 2],
      selectedDepositType: 'timeDepositsInsured',
      currentPage        : 1
    }
  },
  computed: {
    deployedPerDay () {
      if (!this.BankReadiness.items) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.BankReadiness.items).map(item => toNumberFormatNotationShort(item.deployed)), this.currentPage).items
    },
    withdrawnPerDay () {
      if (!this.BankReadiness.items) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.BankReadiness.items).map(item => toNumberFormatNotationShort(item.withdrawn)), this.currentPage).items
    },
    cumulativeWithdrawns () {
      if (!this.BankReadiness.items) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.BankReadiness.items).map(item => toNumberFormatNotationShort(item.cumWithdrawn)), this.currentPage).items
    },
    id () {
      return this.user?.selectedAccountId || null
    },
    tableLabel () {
      const initial = ''

      switch (this.selectedDepositType) {
        case 'timeDepositsInsured':
          return initial + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Insured') + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.TimeDeposits')
        case 'savingsDepositsInsured':
          return initial + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Insured') + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.SavingsDeposits')
        case 'demandDepositsInsured':
          return initial + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Insured') + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DemandDeposits')
        case 'timeDepositsUninsured':
          return initial + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Uninsured') + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.TimeDeposits')
        case 'savingsDepositsUninsured':
          return initial + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Uninsured') + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.SavingsDeposits')
        case 'demandDepositsUninsured':
          return initial + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.Uninsured') + ' ' + this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DemandDeposits')
        default:
          return ''
      }
    },
    leftTableLabel () {
      switch (this.selectedDepositType) {
        case 'timeDepositsInsured':
          return this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.TimeDeposits')
        case 'savingsDepositsInsured':
          return this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.SavingsDeposits')
        case 'demandDepositsInsured':
          return this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DemandDeposits')
        case 'timeDepositsUninsured':
          return this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.TimeDeposits')
        case 'savingsDepositsUninsured':
          return this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.SavingsDeposits')
        case 'demandDepositsUninsured':
          return this.$t('RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.DemandDeposits')
        default:
          return ''
      }
    },
    totalAmountOfDepositsGrouped () {
      switch (this.selectedDepositType) {
        case 'timeDepositsInsured':
        case 'timeDepositsUninsured':
          return this.riskBaseCurrencyDisplayName + toNumberFormatNotationShort(this.DepositBehavior.timeDepositsAmount)
        case 'savingsDepositsInsured':
        case 'savingsDepositsUninsured':
          return this.riskBaseCurrencyDisplayName + toNumberFormatNotationShort(this.DepositBehavior.savingsDepositsAmount)
        case 'demandDepositsInsured':
        case 'demandDepositsUninsured':
          return this.riskBaseCurrencyDisplayName + toNumberFormatNotationShort(this.DepositBehavior.demandDepositsAmount)
        default:
          return ''
      }
    },
    totalAmountOfDeposits () {
      return this.riskBaseCurrencyDisplayName + toNumberFormatNotationShort(this.DepositBehavior[this.selectedDepositType + 'Amount'])
    },
    outflowPerDay () {
      if (!this.tableData.totalOutflow) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.tableData[this.selectedDepositType].amount), this.currentPage).items
    },
    percentagesPerDay () {
      if (!this.tableData[this.selectedDepositType]) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.tableData[this.selectedDepositType].percentage), this.currentPage).items
    },
    getDays () {
      if (!this.DepositBehavior.items) {
        return []
      }
      return getDefenceReadinessPagination(Object.values(this.DepositBehavior.items).map(item => toNumberFormatNotationShort(item.deployed)), this.currentPage).days
    },
    maxPage () {
      if (!this.DepositBehavior.items) {
        return 1
      }
      return getDefenceReadinessPagination(Object.values(this.DepositBehavior.items).map(item => toNumberFormatNotationShort(item.deployed)), this.currentPage).totalPages
    }
  },
  created () {
    // Listen for crisis scenario changes to refresh data
    this.$bus.$on('RiskLiquidity:CrisisScenario:Changed', this.onCrisisScenarioChanged)
  },
  beforeDestroy () {
    this.$bus.$off('RiskLiquidity:CrisisScenario:Changed', this.onCrisisScenarioChanged)
  },
  mounted () {
  },
  methods: {
    onCrisisScenarioChanged (scenario) {
      this.currentPage = 1
    },
    selectDepositType (type) {
      this.selectedDepositType = type

      this.totalPercentages = Object.values(this.tableData[type])
    },
    activeDepositTypeStyle (type) {
      if (this.selectedDepositType === type) {
        return 'font-weight:bold; color: var(--v-synthesis-brand-dark-blue-base); background-color: var(--v-synthesis-brand-lightest-blue-base); border-radius: 8px;'
      }
      return 'color: var(--v-synthesis-ui-grey-01-base); border-radius: 8px;'
    },
    formatDay (day) {
      return day ? this.riskBaseCurrencyDisplayName + day : '-'
    }
  }
}
  </script>

  <style scoped>
  /* Optional: tweak spacing */
  .v-expansion-panel-header {
    font-size: 14px;
    font-weight: 500;
    color: var(--v-synthesis-brand-dark-blue-base);
  }

  .v-expansion-panel-content {
    font-size: 14px;
    font-weight: 500;

  }

  .withdrawals-per-day-header {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-synthesis-ui-grey-01-base);
  }

  .withdrawals-per-day-content {
    font-size: 14px;
    font-weight: 700;
    color: var(--v-synthesis-ui-grey-01-base);
    letter-spacing: 0.2px;
  }
  .withdrawn-rows-container {
      display: grid;
      grid-template-columns: repeat(10, 1fr);
      grid-template-rows: 1fr;
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      align-items: center;
}

  ::v-deep .v-expansion-panel-content__wrap {
  padding-bottom: 0 !important;
}

  </style>
